import styled from 'styled-components';
import { alpha } from '../../../themes/brand';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
`;

export const FormContainer = styled.div`
  width: 100%;
  max-width: 500px;
  background-color: ${props => props.theme.formUserBackground};
  border-radius: 14px;
  padding: 28px;
  border: 1px solid ${props => props.theme.formUserBorder};
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
`;

export const Title = styled.h1`
  color: ${props => props.theme.text};
  margin-bottom: 24px;
  text-align: center;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const InputGroupSmall = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const Label = styled.label`
  color: ${props => props.theme.text};
  font-size: 14px;
`;

export const Input = styled.input`
  width: 100%;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${props => props.theme.inputAddEditUser};
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
  
  &:disabled {
    background-color: ${({ theme }) => theme.background};
    cursor: not-allowed;
  }
  
  &.error-input {
    border-color: ${({ theme }) => theme.error};
    background-color: ${({ theme }) => theme.errorBackground};
  }
`;

export const InputSmall = styled.input`
  width: 100%;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${({ theme }) => theme.primaryAccent};
  font-size: 14px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &::placeholder {
    color: ${({ theme }) => theme.placeholderColor};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
`;

export const InputRow = styled.div`
  display: flex;
  gap: 16px;
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 14px 16px;
  background: linear-gradient(135deg, ${({ theme }) => theme.primary} 0%, ${({ theme }) => theme.primaryHover} 100%);
  color: ${({ theme }) => theme.primaryOn};
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  margin-top: 8px;
  box-shadow: 0 8px 20px ${({ theme }) => alpha(theme.primary, 0.25)};

  &:hover {
    transform: translateY(-1px);
  }
`;

export const Header = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  top: 80px;
  left: 24px;
  z-index: 1;
`;

export const BackButton = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  
  .icon {
    color: ${({ theme }) => theme.arrowBack};
  }

  svg {
    transition: transform 0.2s ease;
  }

  &:hover svg {
    transform: translateX(-2px);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 12px 14px;
  background-color: ${props => props.theme.formUserInput};
  border: 1px solid ${props => props.theme.formUserBorder};
  border-radius: 10px;
  color: ${props => props.theme.inputAddEditUser};
  font-size: 14px;
  appearance: none;
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%238FB0CC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.primaryAccent};
    box-shadow: 0 0 0 3px ${({ theme }) => alpha(theme.primary, 0.2)};
  }
`;